import { combineReducers } from 'redux';
import { albumsReducer } from './reducers/albums';
import { allAlbumsLoadedReducer } from './reducers/all-albums-loaded';
import { allFeaturesLoadedReducer } from './reducers/all-features-loaded';
import { allReviewsReducer } from './reducers/all-reviews';
import { artistsReducer } from './reducers/artists';
import { featuresReducer } from './reducers/features';
import { featureCategoriesReducer } from './reducers/feature-categories';
import { genresReducer } from './reducers/genres';
import { impersonationUserReducer } from './reducers/impersonation-user';
import { isAuthenticatingReducer } from './reducers/is-authenticating';
import { isFetchingRecentAlbumsReducer } from './reducers/is-fetching-recent-albums';
import { isFetchingFeaturesReducer } from './reducers/is-fetching-features';
import { isModalOpenReducer } from './reducers/is-modal-open';
import { notificationsReducer } from './reducers/notifications';
import { labelsReducer } from './reducers/labels';
import { legacyReviewsReducer } from './reducers/legacy-reviews';
import { lastAlbumDocumentReducer } from './reducers/last-album-document';
import { lastFeatureDocumentReducer } from './reducers/last-feature-document';
import { lastReviewDocumentReducer } from './reducers/last-review-document';
import { recentReviewsReducer } from './reducers/recent-reviews';
import { selectedArtistReducer } from './reducers/selected-artist';
import { selectedAlbumReducer } from './reducers/selected-album';
import { selectedFeatureReducer } from './reducers/selected-feature';
import { selectedGenresReducer } from './reducers/selected-genres';
import { selectedLabelsReducer } from './reducers/selected-labels';
import { usersReducer } from './reducers/users';

export const rootReducer = combineReducers({
	albums: albumsReducer,
	allAlbumsLoaded: allAlbumsLoadedReducer,
	allFeaturesLoaded: allFeaturesLoadedReducer,
	allReviews: allReviewsReducer,
	artists: artistsReducer,
	features: featuresReducer,
	featureCategories: featureCategoriesReducer,
	genres: genresReducer,
	labels: labelsReducer,
	isAuthenticating: isAuthenticatingReducer,
	impersonationUser: impersonationUserReducer,
	isFetchingRecentAlbums: isFetchingRecentAlbumsReducer,
	isFetchingFeatures: isFetchingFeaturesReducer,
	isModalOpen: isModalOpenReducer,
	lastAlbumDocument: lastAlbumDocumentReducer,
	lastFeatureDocument: lastFeatureDocumentReducer,
	lastReviewDocument: lastReviewDocumentReducer,
	legacyReviews: legacyReviewsReducer,
	notifications: notificationsReducer,
	recentReviews: recentReviewsReducer,
	selectedArtist: selectedArtistReducer,
	selectedAlbum: selectedAlbumReducer,
	selectedFeature: selectedFeatureReducer,
	selectedGenres: selectedGenresReducer,
	selectedLabels: selectedLabelsReducer,
	users: usersReducer
});
